import BEMHelper from 'react-bem-helper';

export const bem = BEMHelper({ name: 'ChallengeHeader', outputIsString: true });
